<template>
  <div>
    <div class="choice-wrapper" v-for="option of options">
      <input class="choice-input"
             type="checkbox"
             :id="`${prefix}-multiple-${question.id}-${option}`"
             :name="`${prefix}-multiple-${question.id}`"
             :value="option"
             v-model="value"
      >
      <label class="choice-label" :for="`${prefix}-multiple-${question.id}-${option}`">
        <span class="checkmark"></span>
        <span>{{ option }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'multiple-choice',
  props: {
    question: Object,
    answer: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    value: {
      get() {
        return this.answer;
      },
      set(answer) {
        this.$emit('change', answer);
      },
    },
    prefix() {
      return new Date().getTime();
    },
    options() {
      if (this.question) {
        if (this.question.options) {
          return this.question.options;
        } else if (this.question.params) {
          return this.question.params.options;
        }
      }
      return [];
    },
  },
};
</script>

<style scoped lang="scss">
.choice-wrapper {
  display: inline-block;
  position: relative;
  margin-bottom: 10px;

  .choice-label {
    display: flex;
    padding: 0 10px;
    padding-left: 0;
    margin-right: 4px;
    margin-bottom: 0;
    background: white;
    border: 1px solid #757575;
    position: relative;
    cursor: pointer;

    .checkmark {
      width: 24px;
      height: 24px;
      background-color: #fafafa;
      margin-right: 4px;
      border-right: 1px solid #757575;

      &:after {
        display: none;
        content: '';
        position: absolute;
        left: 8px;
        top: 3px;
        width: 8px;
        height: 14px;
        border: solid #54667a;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }

    &:hover .checkmark {
      background-color: #ececec;
    }
  }

  .choice-input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked + .choice-label {
      border-color: #91b269;
      .checkmark {
        background-color: #dae7d4;

        &:after {
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MultipleChoice.vue